import React, { useState } from 'react';
import Image from 'frontastic/lib/image';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop, mediumDesktop, tablet } from 'helpers/utils/screensizes';
import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import { Reference } from 'types/reference';

import Breadcrumb from 'components/commercetools-ui/atoms/breadcrumb';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import { HomeIcon } from '@heroicons/react/24/outline';
import { useFormat } from 'helpers/hooks/useFormat';
import { usePathname, useSearchParams } from 'next/navigation';
import usePath from 'helpers/hooks/usePath';
import usePreloadImages from 'helpers/hooks/usePreloadImages';

export type BathroomProps = {
  data?: any;
};
type ctaButtonType = {
  href: string | Reference | undefined;
  title: string | undefined;
};
const Bathroom = ({ data }: React.PropsWithChildren<BathroomProps>) => {
  const { path } = usePath();
  // const getTitleFromSlug = () => {
  //   if (path.split('/').slice(-2, -1)[0] === 'independent-living') return 'Independent Living & Care';
  //   if (path.split('/').slice(-2, -1)[0] === 'toilet-suites') return 'Toilets';
  //   return `${path.split('/').slice(-2, -1)[0].replaceAll('-', ' ')}`;
  // };
  const generateBreadcrumbs = () => {
    const segments = path.split('/').filter(Boolean);
    return segments.map((segment, index) => {
      const isLast = index === segments.length - 1;
      const url = '/' + segments.slice(0, index + 1).join('/');
      const text = segment.replaceAll('-', ' ').replaceAll('and', '&');

      if (isLast) {
        return (
          <span key={index} className="text-14 font-normal capitalize leading-4 text-[#666]">
            {text}
          </span>
        );
      }

      return (
        <Link key={index} link={url} className="text-14 font-normal capitalize leading-4 text-[#666] hover:underline">
          {text}
        </Link>
      );
    });
  };  
  const Bathroom = data?.sections?.[0]?.section_with_image_text || data?.section_with_image_text || '';
  usePreloadImages([Bathroom?.image?.url]);
  const { formatMessage: formatProductMessage } = useFormat({ name: 'product' });
  return (
    <>
      <div className="hidden px-24 pb-8 pt-16 md:block lg:px-32 md:px-12  xl:px-44 2xl:px-64">
        <Breadcrumb Separator={<ChevronRightIcon className="mt-2 w-16" />} listClassName="!gap-x-16">
          <Link link={'/'}>
            <HomeIcon className="mt-6 w-20" />
          </Link>
          {/* <span className="text-12 font-normal capitalize leading-4 text-[#666]">{getTitleFromSlug()}</span> */}
          {generateBreadcrumbs()}
        </Breadcrumb>
      </div>
      <div className="relative  left-full  w-screen -translate-x-full lg:grid lg:grid-cols-12">
        <div
          id="advice-section"
          className={`flex items-center  lg:col-span-12 lg:px-0 flex-col lg:flex-row-reverse`}
        >
          <div className="relative  h-[25rem] w-full md:h-[55rem] lg:mb-50 lg:h-[30rem] lg:flex-1  lg:flex-grow xl:mb-48 xl:h-[40rem] 2xl:mb-80 2xl:h-[45rem]">
            {Bathroom?.image?.url && (
              <Image
                priority
                src={Bathroom?.image?.url}
                alt={Bathroom?.image?.description}
                fill
                style={{ objectFit: 'cover' }}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                width={500}
                height={500}
              />
            )}
          </div>
          <div className="flex-1 flex-grow lg:px-48 md:px-28 px-24 pb-24 pt-48 xl:px-60 2xl:px-80">
            {Bathroom?.title && (
              <Typography
                as="h1"
                className=" lg:p-16  xl:p-16 2xl:p-16 text-center text-32 font-medium leading-10 text-primary-black md:text-40 lg:text-left lg:leading-[3.5rem] xl:text-left 2xl:text-48"
              >
                {Bathroom?.title}
              </Typography>
            )}
            {Bathroom?.description && (
              <div className=" lg:p-16 xl:p-16 2xl:p-16 list-container pt-24 text-16 font-normal leading-6 text-[#333]  md:text-18 lg:leading-8 2xl:text-20 [&>p]:mb-16" dangerouslySetInnerHTML={{ __html:  Bathroom?.description}}></div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default Bathroom;
